import { PositionStrategy } from 'react-tooltip';

import Tooltip from '@components/tooltip/Tooltip';

interface TruncatedTextTooltipProps {
  id: string;
  text: string;
  positionStrategy?: PositionStrategy; // 'fixed' escapes an ancestor's overflow clipping
}

// Dark tooltip showing the full text of a truncated label
const TruncatedTextTooltip = ({
  id,
  text,
  positionStrategy
}: TruncatedTextTooltipProps) => (
  <Tooltip
    id={id}
    positionStrategy={positionStrategy}
    noArrow={false}
    className="!max-w-72 !bg-cofeeNeutral10 !px-3 !py-2 shadow-tooltipShadow"
  >
    <span className="block break-words text-sm leading-5 text-cofeeNeutral1 [text-wrap:pretty]">
      {text}
    </span>
  </Tooltip>
);

export default TruncatedTextTooltip;
